export default __webpack_public_path__ + "static/media/staff-tee-duong.a3cf0c70.jpg";